module.exports = __webpack_public_path__ + "img/ussr_bg_dashboard.e8317f1d.svg";